module.exports = __webpack_public_path__ + "img/e41.ba63e13c.png";